"use strict";

import React from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { getIntegerFromEvent } from "../../utilities/EventsHelper";
import classNames from "classnames";

import LockIcon from "../../controls/LockIcon.jsx";

// Predefined web timeouts
var timeouts = [
    {
        value: 15, // web timeout in minutes
        text: "15 MINUTES" // a text to display
    },
    {
        value: 30,
        text: "30 MINUTES"
    },
    {
        value: 45,
        text: "45 MINUTES"
    },
    {
        value: 60,
        text: "1 HOUR"
    },
    {
        value: 120,
        text: "2 HOURS"
    },
    {
        value: 180,
        text: "3 HOURS"
    },
    {
        value: 240,
        text: "4 HOURS"
    }
];

export default class WebTimeoutSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showHelp: false };

        this._handleHelpClick = this._handleHelpClick.bind(this);
        this._handleWebTimeoutChange = this._handleWebTimeoutChange.bind(this);
    }

    render() {
        const options = timeouts.map((timeout, index) =>
            <option key={index} value={timeout.value}>{timeout.text}</option>);

        const helpDetailsClass = classNames("helpWidget", { hidden: !this.state.showHelp });

        return (
            <div id="WebTimeoutSettings" className="itemGroup">
                <div className="formControlTitle">Web Timeout</div>
                <select className="picker-hollow" id="webTimeoutPicker" name="select"
                    onChange={this._handleWebTimeoutChange}
                    ref={(c) => this.webTimeoutOptions = c}
                    tabIndex="1"
                    value={this.props.webTimeout}
                    disabled={this.props.disabled}
                >
                    {options}
                </select>
                <div className="helpIcon">
                    <button className="btn btn-link"
                        onClick={this._handleHelpClick}>
                        <i className="material-icons helpIcon">&#xE887;</i>
                    </button>
                    <div className={helpDetailsClass}>
                        By default, users are logged off of the
                        website after 30 minutes of inactivity.
                        Site administrators have the option to change this timeout.
                        To meet HIPAA regulations, SoleSource
                        strongly recommends to stay within
                        30 minutes timeout.
                        <br/>
                        <button
                            onClick={this._handleHelpClick}
                            className=" btn btn-secondary-action center-block pull-right">OK
                        </button>
                    </div>
                </div>
                <LockIcon isLocked={this.props.disabled} />
            </div>
        );
    }

    _handleHelpClick () {
        const showHelp = this.state.showHelp;
        this.setState({ showHelp: !showHelp });
    }

    _handleWebTimeoutChange (e) {
        const webTimeout = getIntegerFromEvent(e);
        this.props.setWebTimeout(webTimeout);
    }
}

WebTimeoutSettings.defaultProps = {
    disabled: false
};

WebTimeoutSettings.propTypes = {
    webTimeout: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired,
    setWebTimeout: PropTypes.func
};
